// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__3DDPL","content__title":"style_content__title__1xppI","content__cardList":"style_content__cardList__1DbxS"};